import template from './template.html';
import './styles.css';
import moment from 'moment';

controller.$inject = ['$timeout', 'AuditService', 'Alerts'];

export function controller($timeout, AuditService, Alerts) {
    const vm = this;
    const PAGE_SIZE = 10;
    const FIRST_PAGE_NUMBER = 1;

    //properties
    vm.currentPage = FIRST_PAGE_NUMBER;
    vm.loadingData = true;
    vm.records = [];

    //functions
    vm.nextPage = nextPage;
    vm.previousPage = previousPage;
    vm.applyFilters = applyFilters;
    vm.showDetail = showDetail;
    vm.getDateFromMaxLimit = getDateFromMaxLimit;
    vm.getDateToMinLimit = getDateToMinLimit;

    getRecordsForCurrentPage();

    function getDateFromMaxLimit() {
        return vm.dateToFilter ? moment(vm.dateToFilter, 'DD-MM-YYYY').format('DD MMMM YYYY') : undefined;
    }

    function getDateToMinLimit() {
        return vm.dateFromFilter ? moment(vm.dateFromFilter, 'DD-MM-YYYY').format('DD MMMM YYYY') : undefined;
    }


    function nextPage() {
        if (vm.records.length > 0 && vm.records.length == PAGE_SIZE) {
            vm.currentPage += 1;
            getRecordsForCurrentPage();
        }
    }

    function previousPage() {
        if (vm.currentPage > FIRST_PAGE_NUMBER) {
            vm.currentPage -= 1;
            getRecordsForCurrentPage();
        }
    }

    function getRecordsForCurrentPage() {
        vm.loadingData = true;
        vm.records.length = 0;

        let dateFrom = vm.dateFromFilter ? moment(vm.dateFromFilter + ' 00:00:00', 'DD-MM-YYYY HH:mm:SS').format('DD MMMM YYYY, HH:mm:SS') : undefined;
        let dateTo = vm.dateToFilter ? moment(vm.dateToFilter + ' 23:59:59', 'DD-MM-YYYY HH:mm:SS').format('DD MMMM YYYY, HH:mm:SS') : undefined;

        AuditService.getRecords(vm.currentPage, PAGE_SIZE, dateFrom, dateTo, vm.entityFilter, vm.actionFilter, vm.userFilter)
            .then(records => {
                vm.records = records;
                vm.loadingData = false;
            });
    }

    function applyFilters() {
        vm.currentPage = FIRST_PAGE_NUMBER;
        getRecordsForCurrentPage();
    }

    function showDetail(transaction) {
        vm.selectedTransaction = transaction;
        AuditService.getRecord(transaction.transactionKey, transaction.rowId).then(details => {
            if (details && details.constructor === Array) {
                details.forEach(item => {
                    if (item.column != 'Description')
                    {
                        item.oldValue = parseIfDate(item.oldValue);
                        item.newValue = parseIfDate(item.newValue);   
                    }
                });
            }

            vm.selectedDetails = details;
            //use $timeout to ensure that we only get details html once digest cycle has finished after setting vm.selectedDetails
            $timeout(() => {
                Alerts.show({
                    title: 'Transaction Details',
                    text: document.getElementById('sweetalert-details').innerHTML,
                    html: true
                });
            });
        });
    }

    function parseIfDate(value) {
        var iValue = Number(value);

        if (!isNaN(iValue)) return value;

        var dateValue = Date.parse(value);

        if (!isNaN(dateValue)) {
            return moment(new Date(dateValue)).format("DD/MM/YYYY HH:mm");
        }

        return value;
    }
}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('audit', {
        controller: controller,
        controllerAs: 'vm',
        parent: 'authorised',
        template: template,
        url: '/audit'
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/authorised/auditlist/index.js